import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-slate-100 max-w-4xl mx-auto my-10">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-4 tracking-tight">Privacy Policy</h1>
      <p className="text-slate-500 font-medium mb-12">Last Updated: April 1, 2026</p>
      
      <div className="text-slate-600 space-y-8 leading-relaxed">
        <p>
          Welcome to <strong className="text-indigo-600">pass-photo.in</strong> ("we," "our," or "us"). We are committed to protecting your privacy while you use our free AI-powered passport photo generation tool. This Privacy Policy explains how we collect, use, and safeguard your information.
        </p>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Information We Collect</h2>
          <p className="mb-2">When you visit and use our website, we collect two main types of information:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Image Data:</strong> The photos you upload to generate passport-sized images.</li>
            <li><strong>Non-Personal Data:</strong> General usage information such as your browser type, device type, IP address, and how you interact with our website.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">2. Image Processing and Storage</h2>
          <p className="mb-2">Your privacy is our top priority. We understand that photos are highly personal.</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>No Permanent Storage:</strong> We do not permanently store, save, or share any images you upload.</li>
            <li><strong>Temporary Processing:</strong> Your images are processed temporarily on our secure servers or via our trusted third-party AI APIs solely for the purpose of removing the background and formatting the photo. Once the generated photo is sent back to you, the original and processed images are immediately deleted from our system.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">3. Third-Party Services</h2>
          <p className="mb-2">We use trusted third-party services to ensure our website runs efficiently and remains free for you to use:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>AI APIs:</strong> Used strictly for image processing (like background removal). These services also adhere to strict privacy guidelines and do not use your images for public training data.</li>
            <li><strong>Google AdSense:</strong> We use Google AdSense to serve advertisements. Google may use cookies to serve ads based on your prior visits to our website or other websites on the internet.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">4. Cookies</h2>
          <p>
            We use cookies to improve your user experience and for advertising purposes. Cookies are small text files stored on your device. You can choose to disable cookies through your browser settings, though this may affect how certain features of our site function.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">5. User Privacy Protection</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to outside parties. Your data is handled with the utmost security using industry-standard encryption during transit.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">6. Changes to this Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. The modified policy will be highlighted by the "Last Updated" date at the top of this page.
          </p>
        </section>

        <section className="bg-indigo-50 border border-indigo-100 p-6 rounded-2xl mt-10">
          <h2 className="text-xl font-bold text-indigo-900 mb-2">7. Contact Us</h2>
          <p className="text-indigo-800 mb-4">
            If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at:
          </p>
          <p className="font-semibold text-indigo-600">Email: <a href="mailto:darkcoder.studio@gmail.com" className="hover:underline">darkcoder.studio@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
